import React, { useEffect, useRef } from 'react';
import { rubrosHistoricos } from '../../json/rubrosHistoricos';
import styles from '../../styles/cards.module.css';

const RubrosHistoricos = () => {
    const containerRef = useRef(null);

    useEffect(() => {
        window.scrollTo(0, 0);

        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;

        if (containerRef.current) {
            containerRef.current.scrollTop = 0;
        }

        setTimeout(() => {
            window.scrollTo(0, 0);
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
            if (containerRef.current) {
                containerRef.current.scrollTop = 0;
            }
        }, 50);

    }, []);

    return (
        <div ref={containerRef} className='container transparencia-container'>
            <div className='row'>
                <div className='col_12'>
                    <div className='transparencia_title'>
                        <h3 className={ styles.title }>
                            Información histórica ejercicios anteriores Art. 69 (48 Fracciones)
                        </h3>
                        <hr className="hr-gob"></hr>
                    </div>
                </div>
                {
                    rubrosHistoricos.map((item, index) => (
                        <div key={ index } className="col-md-3 col-sm-6 col-12">
                            <div className={ styles.container }>
                                <h5 className={ styles.name }>
                                    { item.anio } <br/> { item.descripcion }
                                </h5>
                                <hr></hr>
                                    {
                                        item.trimestres.map((trim, idx) => (
                                        <div key={ index }>
                                            <a className={ styles.link } href={ trim.url } target='_blank' rel='noopener noreferrer'>
                                                <div className={ styles.item }>
                                                    <p className={ styles.textLink }>
                                                        { trim.trimestre }
                                                    </p>
                                                    <i className={ `icon-file-zip ${ styles.iconLink }`}></i>
                                                </div>
                                            </a>
                                        </div>
                                        ))
                                    }
                             </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default RubrosHistoricos;
